<app-header [selectedMenu]="selectedMenu"></app-header>

<div class="container" (scroll)="onScrollTop($event)">

  <!-- div class="wrapper" #main
       (click)="onFocusMain($event)" -->
  <div class="wrapper">

    <aside class="rope"></aside>
    <app-back-btn></app-back-btn>

    <section class="search-result">

      <div class="inner wrap">

        <app-search-box [placeholder]="placeholder"
                        [keyword]="keyword"
                        [keyHistoryKeyword]="HISTORY_KEY_SEARCH_PROVERB"
                        [top]="scrollTop"
                        (search)="onSearch($event)"></app-search-box>

        <div class="search-body-box">


          <article class="book-layout2">

            <div class="book-layout-wrap">

              <div class="book-page-list">

                <app-jaso-index [curJasoIdx]="curJasoIdx"
                                [second]="true"
                                [btnSize]="28"
                                [rightStart]="-27"
                                (search)="onSearch($event)"></app-jaso-index>

                <div class="book-page-group">


                  <div class="page-box">
                    <div class="page-contents scroll-effect over-y">
                      <article class="proverb-list-layout">

                        <div class="list-wrap" *ngIf="!IsLoading">

                          <ul>
                            <li *ngFor="let proverb of ListLeft"
                                #proverbItem
                                [attr.data-proverb-id]="proverb.id"
                                [class.extend]="(ListLeft?.length ?? 0) % PROVERB_PAGE_HALF_SIZE === 0"
                                [class.selected]="IsSelected(proverb)"
                                [attr.aria-current]="IsSelected(proverb) ? 'true' : null">
                              <app-proverb-detail [proverb]="proverb"
                                                  [selected]="IsSelected(proverb)"
                                                  [expanded]="IsSelected(proverb)"
                                                  [class.selected]="IsSelected(proverb)"
                                                  (click)="Unfold($event, proverb)"
                                                  (bookmarkChange)="onBookmarkChange($event)"></app-proverb-detail>
                            </li>

                            <!-- 목록이 비었다는 표시 -->
                            <li class="no-result" *ngIf="pl?.getList()?.length === 0">
                              <div class="no-result-img"></div>
                              <div class="no-result-txt">속담이 없습니다.</div>
                            </li>
                          </ul>

                        </div>

                        <!-- 로딩중이라는 표시 -->
                        <div class="reload-img" *ngIf="IsLoading"></div>

                      </article>

                    </div>

                    <article class="page-navigation">
                      <a class="prev-btn {{ GetPreBtnCss() }}" (click)="goPrePage($event)"></a>
                    </article>

                  </div>
                  <div class="page-box">


                    <div class="page-contents scroll-effect over-y">
                      <article class="proverb-list-layout">
                        <div class="list-wrap">

                          <ul>
                            <li *ngFor="let proverb of ListRight"
                                #proverbItem
                                [attr.data-proverb-id]="proverb.id"
                                [class.extend]="(ListRight?.length ?? 0) % PROVERB_PAGE_HALF_SIZE === 0"
                                [class.selected]="IsSelected(proverb)"
                                [attr.aria-current]="IsSelected(proverb) ? 'true' : null">
                              <app-proverb-detail [proverb]="proverb"
                                                  [selected]="IsSelected(proverb)"
                                                  [expanded]="IsSelected(proverb)"
                                                  [class.selected]="IsSelected(proverb)"
                                                  (click)="Unfold($event, proverb)"
                                                  (bookmarkChange)="onBookmarkChange($event)"></app-proverb-detail>
                            </li>

                          </ul>
                        </div>
                      </article>

                    </div>

                    <article class="page-navigation">
                      <div *ngIf="showPageNumber()" class="page">
                        {{ getCurrrentPage() }} / {{ getTotalPage() }}
                      </div>
                      <a class="next-btn {{ GetNextBtnCss() }}"
                         (click)="goNextPage($event)"></a>
                    </article>

                  </div>
                </div>


              </div>

            </div>



          </article>

        </div>

      </div>

    </section>


  </div>


  <!-- app-footer></app-footer -->
  <app-common-popups></app-common-popups>

</div>
